import React, { useState, useEffect } from "react";

import NoAnswer from "../components/NoAnswer";
import NotBestTime from "../components/NotBestTime";
import BestTime from "../components/BestTime";
import WrongAnswer from "../components/WrongAnswer";

const Over = ({
  lts = false,
  key,
  player,
  sound_in,
  playAudio,
  playerInfo,
  mobile_app,
  logo_mobile,
  over_params,
  answers_array,
  correct_answer,
  top_logo_mobile,
  set_has_answered
}) => {
  const [isAnswerCorrect, setIsAnswerCorrect] = useState();
  const [isBestTime, setIsBestTime] = useState();
  const [yourTime, setYourTime] = useState();
  const [bestTime, setBestTime] = useState();
  const [noAnswer, setNoAnswer] = useState();
  const [yourAnswer, setYourAnswer] = useState();

  // useEffect(() => {
  //   set_has_answered(false);
  // }, []);

  useEffect(() => {
    setNoAnswer(playerInfo?.answer_time ? false : true);
    if (isAnswerCorrect === undefined) {
      setIsAnswerCorrect(correct_answer === playerInfo?.answer);
    } else {
      let time = playerInfo?.answer_time;
      player.forEach((value) => {
        correct_answer === value.answer &&
          value.answer_time < time &&
          (time = value.answer_time);
      });
      setYourAnswer(answers_array[playerInfo?.answer]);
      setIsBestTime(playerInfo?.answer_time === time);
      setYourTime(playerInfo?.answer_time);
      setBestTime(time);
    }
  }, [isAnswerCorrect]);

  // useEffect(() => {
  //   return () => playAudio(sound_in);
  // }, []);

  const get_component = () => {
    if (
      isAnswerCorrect !== undefined &&
      isBestTime !== undefined &&
      noAnswer !== undefined
    ) {
      if (isAnswerCorrect) {
        if (isBestTime)
          return (
            <BestTime
              key={key}
              lts={lts}
              yourTime={yourTime}
              mobile_app={mobile_app}
              yourAnswer={yourAnswer}
              logo_mobile={logo_mobile}
              over_params={over_params}
              top_logo_mobile={top_logo_mobile}
            />
          );
        else
          return (
            <NotBestTime
              key={key}
              lts={lts}
              bestTime={bestTime}
              yourTime={yourTime}
              mobile_app={mobile_app}
              yourAnswer={yourAnswer}
              logo_mobile={logo_mobile}
              over_params={over_params}
              top_logo_mobile={top_logo_mobile}
            />
          );
      } else {
        if (noAnswer)
          return (
            <NoAnswer
              key={key}
              lts={lts}
              mobile_app={mobile_app}
              logo_mobile={logo_mobile}
              over_params={over_params}
              top_logo_mobile={top_logo_mobile}
              correctAnswer={answers_array && answers_array[correct_answer]}
            />
          );
        else
          return (
            <WrongAnswer
              key={key}
              lts={lts}
              yourAnswer={yourAnswer}
              mobile_app={mobile_app}
              logo_mobile={logo_mobile}
              over_params={over_params}
              top_logo_mobile={top_logo_mobile}
              correctAnswer={answers_array && answers_array[correct_answer]}
            />
          );
      }
    } else return <></>;
  };

  return <>{get_component()}</>;
};

export default Over;
